module.exports = "/images/start-a-promotional-offer.svg?3e92e12d204c019c847878f6c65bc766";